export default __webpack_public_path__ + "static/media/8S.fd5cd6f8.svg";